import { BlockType } from '../../types/index.js';
import { FieldViewBlock as Component } from './Block.js';
export const RegisteredFieldViewBlock = (_intl) => ({
    recommendedName: 'FieldView',
    Component,
    config: {
        type: BlockType.Block,
        usable: false,
        displayName: 'Field View',
        defaultProps: {
            collapsible: false,
            highlighted: false,
            preview: false,
            showLabel: false,
        },
    },
});
//# sourceMappingURL=registered.js.map